import { NgIf, NgFor, AsyncPipe } from '@angular/common'
import { AfterViewInit, Component, OnInit, QueryList, ViewChildren } from '@angular/core'
import { CmsService, CMSTabParagraphContainer, WindowRef, TranslatePipe } from '@spartacus/core'
import {
  BREAKPOINT,
  BreakpointService,
  CmsComponentData,
  ComponentWrapperDirective,
  OutletDirective
} from '@spartacus/storefront'
import { combineLatest, Observable } from 'rxjs'
import { distinctUntilChanged, map, switchMap, take } from 'rxjs/operators'
@Component({
  selector: 'eb-tab-paragraph-container',
  templateUrl: './eb-tab-paragraph-container.component.html',
  styleUrls: ['./eb-tab-paragraph-container.component.scss'],
  imports: [NgIf, NgFor, OutletDirective, ComponentWrapperDirective, AsyncPipe, TranslatePipe]
})
export class EbTabParagraphContainerComponent implements AfterViewInit, OnInit {
  activeTabNum = 0

  @ViewChildren(ComponentWrapperDirective)
  children!: QueryList<ComponentWrapperDirective>

  tabTitleParams: (Observable<any> | null)[] = []

  constructor(
    public componentData: CmsComponentData<CMSTabParagraphContainer>,
    protected cmsService: CmsService,
    protected winRef: WindowRef,
    protected breakpointService: BreakpointService
  ) {}

  components$: Observable<any[]> = this.componentData.data$.pipe(
    distinctUntilChanged((x, y) => x?.components === y?.components),
    switchMap(data =>
      combineLatest(
        (data?.components ?? '').split(' ').map(component =>
          this.cmsService.getComponentData<any>(component).pipe(
            distinctUntilChanged(),
            map(tab => {
              if (!tab) {
                return undefined
              }

              if (!tab.flexType) {
                tab = {
                  ...tab,
                  flexType: tab.typeCode
                }
              }

              return {
                ...tab,
                title: `${data.uid}.tabs.${tab.uid}`
              }
            })
          )
        )
      )
    )
  )

  select(tabNum: number, event?: MouseEvent): void {
    this.breakpointService
      ?.isDown(BREAKPOINT.sm)
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.activeTabNum = this.activeTabNum === tabNum ? -1 : tabNum
          if (event?.target) {
            const target = event.target as HTMLElement
            const parentNode = target.parentNode as HTMLElement
            this.winRef?.nativeWindow?.scrollTo(0, parentNode.offsetTop)
          }
        } else {
          this.activeTabNum = tabNum
        }
      })
  }

  ngOnInit(): void {
    this.activeTabNum = this.winRef?.nativeWindow?.history?.state?.activeTab ?? this.activeTabNum
  }

  ngAfterViewInit(): void {
    // If the sub cms components data exist, the components created before ngAfterViewInit are called.
    // In this case, the title parameters are directly pulled from them.
    if (this.children.length > 0) {
      this.getTitleParams(this.children)
    }
  }

  tabCompLoaded(componentRef: any): void {
    this.tabTitleParams.push(componentRef.instance.tabTitleParam$)
  }

  private getTitleParams(children: QueryList<ComponentWrapperDirective>) {
    children.forEach(comp => {
      this.tabTitleParams.push(null)
    })
  }
}
